// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changelog {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  font-family: Inter, Arial, Helvetica, sans-serif;
  color: #e5e7eb;
  background: #111827;
  line-height: 1.7;
}

/* Main title */
.changelog h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
  border-bottom: 2px solid #374151;
  padding-bottom: 0.5rem;
}

/* Section headers */
.changelog h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #60a5fa;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.changelog h3 {
  font-size: 1.25rem;
  margin-top: 1.5rem;
  color: #93c5fd;
}

/* Paragraphs */
.changelog p {
  margin-bottom: 0.75rem;
}

/* Bold labels */
.changelog strong {
  color: #f9fafb;
  font-weight: 700;
}

/* Lists */
.changelog ul,
.changelog ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

.changelog li {
  margin-bottom: 0.5rem;
}

/* Links */
.changelog a {
  color: #60a5fa;
  text-decoration: none;
}

.changelog a:hover {
  text-decoration: underline;
}

/* Code blocks */
.changelog pre {
  background: #1f2937;
  padding: 1rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 1rem 0;
}

.changelog code {
  background: #1f2937;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
}

/* Horizontal rules */
.changelog hr {
  border: none;
  border-top: 1px solid #374151;
  margin: 2rem 0;
}

/* Tables */
.changelog table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.changelog th,
.changelog td {
  border: 1px solid #374151;
  padding: 0.75rem;
  text-align: left;
}

.changelog th {
  background: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".changelog {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n  font-family: Inter, Arial, Helvetica, sans-serif;\r\n  color: #e5e7eb;\r\n  background: #111827;\r\n  line-height: 1.7;\r\n}\r\n\r\n/* Main title */\r\n.changelog h1 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  margin-bottom: 1rem;\r\n  border-bottom: 2px solid #374151;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n/* Section headers */\r\n.changelog h2 {\r\n  font-size: 1.75rem;\r\n  font-weight: 600;\r\n  color: #60a5fa;\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.changelog h3 {\r\n  font-size: 1.25rem;\r\n  margin-top: 1.5rem;\r\n  color: #93c5fd;\r\n}\r\n\r\n/* Paragraphs */\r\n.changelog p {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n/* Bold labels */\r\n.changelog strong {\r\n  color: #f9fafb;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Lists */\r\n.changelog ul,\r\n.changelog ol {\r\n  margin-left: 1.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.changelog li {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n/* Links */\r\n.changelog a {\r\n  color: #60a5fa;\r\n  text-decoration: none;\r\n}\r\n\r\n.changelog a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Code blocks */\r\n.changelog pre {\r\n  background: #1f2937;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  overflow-x: auto;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.changelog code {\r\n  background: #1f2937;\r\n  padding: 0.2rem 0.4rem;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Horizontal rules */\r\n.changelog hr {\r\n  border: none;\r\n  border-top: 1px solid #374151;\r\n  margin: 2rem 0;\r\n}\r\n\r\n/* Tables */\r\n.changelog table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.changelog th,\r\n.changelog td {\r\n  border: 1px solid #374151;\r\n  padding: 0.75rem;\r\n  text-align: left;\r\n}\r\n\r\n.changelog th {\r\n  background: #1f2937;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
